
import HIcon from '../../atoms/icons/h-icon';

// TODO: transform tableData structure to this:
// [
//   [{ value: '46.400 $', class: '' }, { value: 0, class: '' }],
//   [{ value: '397 $', class: '' }, { value: 560 $, class: '' }],
//   [{ value: '11.97 %', class: '' }, { value: 6,08 %, class: '' }],
// ]
// With the class we can adapt the display of each item

export default {
  name: 'ComparisonTable',

  components: {
    HIcon,
  },

  props: {
    columns: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    },
    selectedColumn: {
      type: Number,
      default: -1,
    },
    selectedIcon: {
      type: String,
      default: '',
    },
    selectedTitle: {
      type: String,
      default: '',
    },
    tableData: {
      type: Array,
      required: true,
    },
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  }
};
